// Modal and Pin Close Handlers
const initModalCloseButton = () => {
    const modal = document.getElementById('modal-consultation');
    if (!modal) {
        console.error('Modal not found');
        return;
    }

    // Close button
    const closeBtn = modal.querySelector('.modal-close-simple');
    if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Closing modal');
            modal.classList.remove('modal--active');
            document.body.style.overflow = 'auto';
        });
        console.log('Modal close button listener added');
    } else {
        console.error('Close button not found');
    }

    // Overlay click
    const overlay = modal.querySelector('.modal__overlay');
    if (overlay) {
        overlay.addEventListener('click', function () {
            modal.classList.remove('modal--active');
            document.body.style.overflow = 'auto';
        });
    }

    // Floating pin close button
    const pinCloseBtn = document.querySelector('.pin-close-btn');
    if (pinCloseBtn) {
        pinCloseBtn.removeAttribute('onclick'); // Remove inline handler
        pinCloseBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const pin = document.querySelector('.pin');
            if (pin) {
                console.log('Toggling pin closed state');
                pin.classList.toggle('pin--closed');
            }
        });
        console.log('Pin close button listener added');
    }
};

export { initModalCloseButton };
